import store from '@/store/index'
import ability from '@/libs/acl/ability'
import { computed } from '@vue/composition-api'
import jwt from '@/auth/jwt/useJwt'

/**
 * Reactive user object
 */
export const useUser = () => {
  const user = computed(() => store.getters['account/user'])
  const userAuthorized = computed(() => !!user.value?.id)
  return { user, userAuthorized }
}

const LOGGED_IN_TTL_MS = 30_000
let lastCheckAt = 0
let lastCheckResult = false
let inFlight = null

const clearFrontendUserState = () => {
  try { store.commit('account/clearUser') } catch (_) {}
  try { store.commit('user/unsetUserManaged') } catch (_) {}
}

export const isUserLoggedIn = async () => {
  // If logout is in progress, never block routing with an API call
  try {
    if (sessionStorage.getItem('auth.logoutInProgress') === '1') return false
  } catch (_) {}

  // No tokens => guest (also clear stale UI user)
  const hasToken = !!jwt.getToken() || !!jwt.getRefreshToken()
  if (!hasToken) {
    lastCheckAt = 0
    lastCheckResult = false
    inFlight = null
    clearFrontendUserState()
    return false
  }

  // If user already in store, return true quickly
  const user = store.getters['account/user']
  if (user?.id) return true

  const now = Date.now()
  if ((now - lastCheckAt) < LOGGED_IN_TTL_MS) return lastCheckResult
  if (inFlight) return inFlight

  inFlight = store
    .dispatch('account/getUserCurrent')
    .then(response => {
      const ok = response?.status === 200
      lastCheckAt = Date.now()
      lastCheckResult = ok || !!store.getters['account/user']?.id
      return lastCheckResult
    })
    .catch(() => {
      lastCheckAt = Date.now()
      lastCheckResult = false
      return false
    })
    .finally(() => { inFlight = null })

  return inFlight
}

export const getUserData = () => store.getters['account/user']

export const getHomeRouteForLoggedInUser = () => {
  if (ability.can('update', 'Account')) {
    return { name: 'pages-account-setting' }
  }
  return { name: 'auth', query: { form: 'login' } }
}
